import mutations from './mutations';

const state = {
  pages: []
};

export default {
  namespaced: true,
  state,
  mutations
};
